import { Temporal } from '../temporal';
import { EMPTY_VALUE } from './constants';

const DEFAULT_LOCALE = 'cs-CZ';
const DEFAULT_TZ = 'Europe/Prague';

/** Timestamp format: "19. 11. 2025 14:30" */
export function formatTimestamp(
  instant: Temporal.Instant | null | undefined,
  locale: string = DEFAULT_LOCALE,
  timeZone: string = DEFAULT_TZ
): string {
  if (instant == null) return EMPTY_VALUE;
  return instant.toLocaleString(locale, {
    timeZone,
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

/** ISO 8601 datetime string */
export function formatTimestampISO(instant: Temporal.Instant | null | undefined): string {
  if (instant == null) return EMPTY_VALUE;
  return instant.toString();
}

/** Dot timestamp: "19.11.2025 14:30" */
export function formatDotTimestamp(
  instant: Temporal.Instant | null | undefined,
  timeZone: string = DEFAULT_TZ
): string {
  if (instant == null) return EMPTY_VALUE;
  const zdt = instant.toZonedDateTimeISO(timeZone);
  const d = String(zdt.day).padStart(2, '0');
  const m = String(zdt.month).padStart(2, '0');
  const h = String(zdt.hour).padStart(2, '0');
  const min = String(zdt.minute).padStart(2, '0');
  return `${d}.${m}.${zdt.year} ${h}:${min}`;
}
